import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { useSetting } from '../../util/useSetting';
import ShortTask from './components/ShortTasks';
import PracticeTask from './components/PracticeTasks';

const RESEARCHES = [
    {
        id: '香港學生睡眠',
        name: '香港學生睡眠',
        image: '/secondary/tasks/r1.png',
        subtitle: '研究測試 1'
    },
    {
        id: '機器人',
        name: '機器人',
        image: '/secondary/tasks/r2.png',
        subtitle: '研究測試 2'
    },
]



function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(RESEARCHES.filter(item => item.id === id)?.[0])
    const [isLoading, setisLoading] = useState(false)
    const { fontSize } = useSetting();




    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {}
        // if (status !== '全部') filter.status = status
        // let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        // if (result.result) {
        //     setdata(result.result)
        //     settotal(result.count || 0)
        // } else {
        //     alert('Fetch data error')
        // }
        setisLoading(false)
    }



    useEffect(() => {
        const timer = setTimeout(fetchData, 500)
        // const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])


    const [isDoingShortTask, setisDoingShortTask] = useState(true)
    const [isDoingReadingTask, setisDoingReadingTask] = useState(false)


    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px]' style={{ fontSize }}>

            {isDoingShortTask && <ShortTask onSubmit={() => {
                    setisDoingShortTask(false);
                    setisDoingReadingTask(true);
            }} />}
            {isDoingReadingTask && <PracticeTask onSubmit={() => {
                    setisDoingReadingTask(false);
            }} />}

            {isLoading && <LoadingPage />}
        </div>
    );
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
